import { isAnnotationLocked } from '../utils/annotationLockUtils';

export const UNGROUP_SELECTED_ANNOTATIONS = 'UNGROUP_SELECTED_ANNOTATIONS';

const ungroupSelectedAnnotations = (state, payload = {}) => {
  const { annotationIds = [] } = payload;
  if (annotationIds.length === 0) {
    return state;
  }

  let annotations = state.annotations;
  let changed = false;

  annotationIds.forEach((id) => {
    const existing = annotations[id];
    if (!existing?.groupId || isAnnotationLocked(existing)) {
      return;
    }
    if (!changed) {
      annotations = { ...state.annotations };
      changed = true;
    }
    const { groupId, ...rest } = existing;
    annotations[id] = rest;
  });

  if (!changed) {
    return state;
  }

  return {
    ...state,
    isDesignState: true,
    annotations,
  };
};

export default ungroupSelectedAnnotations;
